const ProgressBar = (props) => {
    const { bgcolor, completed } = props;

    const containerStyles = {
        height: 8,
        width: window.innerWidth > 767 ? 130 : 95,
        backgroundColor: "#B2B0BF",
        borderRadius: 12,
        position: 'relative'
    }

    const fillerStyles = {
        height: '100%',
        width: `${completed}%`,
        backgroundColor: bgcolor,
        textAlign: 'right',
        borderRadius: 12
    }

    const labelStyles = {
        padding: 0,
        marginLeft: window.innerWidth > 767 ? 154 : 115,
        position: 'absolute',
        top: -80,
        left: -18,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 12,
        color: '#535259',
        lineHeight: 14
    }

    return (
        <div id='contain' style={containerStyles}>
            <div style={fillerStyles}>
            </div>
            <span style={labelStyles}>{`${completed}%`}</span>
        </div>
    );
};

export default ProgressBar;